<template>
  <div style="padding: 10px 0">
    <div class="introduction">
      <el-tabs v-model="activeName" :stretch="true">

        <el-tab-pane label="2023" name="seven">
          <el-timeline>
            <el-timeline-item :timestamp="item.itemTime" placement="top" color="#409EFF"
              v-for="(item, index) in tableData23" :key="index">
              <div class="item_name">{{ item.itemName }}</div>
              <el-image v-if="item.itemImage" style="width: 500px; height: 300px" :src="item.itemImage"
                :preview-src-list="previewImage(item.itemImage)">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
        <el-tab-pane label="2022" name="sixth">
          <el-timeline>
            <el-timeline-item :timestamp="item.itemTime" placement="top" color="#409EFF"
              v-for="(item, index) in tableData22" :key="index">
              <div class="item_name">{{ item.itemName }}</div>
              <el-image v-if="item.itemImage" style="width: 500px; height: 300px" :src="item.itemImage"
                :preview-src-list="previewImage(item.itemImage)">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
        <el-tab-pane label="2021" name="fifth">
          <el-timeline>
            <el-timeline-item :timestamp="item.itemTime" placement="top" color="#409EFF"
              v-for="(item, index) in tableData21" :key="index">
              <div class="item_name">{{ item.itemName }}</div>
              <el-image v-if="item.itemImage" style="width: 500px; height: 300px" :src="item.itemImage"
                :preview-src-list="previewImage(item.itemImage)">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
        <el-tab-pane label="2020" name="fourth">
          <el-timeline>
            <el-timeline-item :timestamp="item.itemTime" placement="top" color="#409EFF"
              v-for="(item, index) in tableData20" :key="index">
              <div class="item_name">{{ item.itemName }}</div>
              <el-image v-if="item.itemImage" style="width: 500px; height: 300px" :src="item.itemImage"
                :preview-src-list="previewImage(item.itemImage)">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
        <el-tab-pane label="2019" name="third">
          <el-timeline>
            <el-timeline-item :timestamp="item.itemTime" placement="top" color="#409EFF"
              v-for="(item, index) in tableData19" :key="index">
              <div class="item_name">{{ item.itemName }}</div>
              <el-image v-if="item.itemImage" style="width: 500px; height: 300px" :src="item.itemImage"
                :preview-src-list="previewImage(item.itemImage)">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
        <el-tab-pane label="2018" name="second">
          <el-timeline>
            <el-timeline-item :timestamp="item.itemTime" placement="top" color="#409EFF"
              v-for="(item, index) in tableData18" :key="index">
              <div class="item_name">{{ item.itemName }}</div>
              <el-image v-if="item.itemImage" style="width: 500px; height: 300px" :src="item.itemImage"
                :preview-src-list="previewImage(item.itemImage)">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
        <el-tab-pane label="2017" name="first">
          <el-timeline>
            <el-timeline-item :timestamp="item.itemTime" placement="top" color="#409EFF"
              v-for="(item, index) in tableData17" :key="index">
              <div class="item_name">{{ item.itemName }}</div>
              <el-image v-if="item.itemImage" style="width: 500px; height: 300px" :src="item.itemImage"
                :preview-src-list="previewImage(item.itemImage)">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>




      </el-tabs>
    </div>
  </div>
</template>
<script>
import { itemList } from './data'
import itemList2   from './newdata'
export default {
  data() {
    return {
      activeName: 'seven',
      scrollReveal: '',
      tableData17: [],
      tableData18: [],
      tableData19: [],
      tableData20: [],
      tableData21: [],
      tableData22: [],
      tableData23: [],
    }
  },
  mounted() {
    this.tableData17 = itemList.filter((key) => key.itemYear === '2017')
    this.tableData18 = itemList.filter((key) => key.itemYear === '2018')
    this.tableData19 = itemList.filter((key) => key.itemYear === '2019')
    this.tableData20 = itemList.filter((key) => key.itemYear === '2020')
    this.tableData21 = itemList.filter((key) => key.itemYear === '2021')
    this.tableData22 = itemList2[0].data;
    this.tableData23 = itemList2[1].data;
  },
  methods: {
    previewImage(url) {
      if (url) {
        var urlArr = []
        urlArr.push(url)
        return urlArr
      }
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/ .el-timeline-item__node--normal {
  left: -5px;
  width: 20px;
  height: 20px;
  z-index: 99;
}

/deep/ .el-tabs__header {
  margin: 0 0 65px;
}

/deep/ .el-tabs__nav {
  width: 100%;
  margin-left: 0;
}

/deep/ .el-tabs__item {
  height: 60px;
  line-height: 60px;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  padding: 0;
  width: 20%;
}

/deep/ .el-timeline-item__timestamp.is-top {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}

/deep/ .el-tabs {
  width: 800px;
  // border: 1px solid;
  margin: 0 auto;
}

/deep/ .el-tabs__content {
  padding: 0 10px;
}

/deep/.el-timeline-item {
  padding-bottom: 60px;
  // border: 1px solid red;
  box-sizing: border-box;
}

.introduction {
  padding: 40px 8%;
  box-sizing: border-box;
  min-height: 750px;
  // border: 1px solid red;

  .item_name {
    margin: 15px 0 30px 0;
    font-size: 16px;
    color: #333333;
  }

  // .image-slot {
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   border: 1px solid red;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/website/aboutUs/component/developmenthistory.vue